var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"load-more-button s-align-5",attrs:{"disabled":_vm.status}},[(!_vm.status)?_c('span',{staticClass:"f-12-blue f-sbold"},[_vm._v("\n        Load More\n    ")]):_vm._e(),(_vm.status)?_c('loading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }